import { Controller, useFormContext } from 'react-hook-form'

import { Input } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'internalReference'

const InternalReferenceField = ({
  isFieldMandatory,
  isFieldReadOnly
}: WithCustomizationFieldsProps & WithFieldPermissionsProps) => {
  const {
    control,
    formState: { errors }
  } = useFormContext()

  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => (
        <Input
          label={i18n.t('expenses_v2.forms.fields.reference.label')}
          value={field.value ?? ''}
          onChange={(value) => field.onChange(value)}
          placeholder={i18n.t('expenses_v2.forms.fields.reference.placeholder')}
          error={castError(errors?.internalReference)}
          required={isFieldMandatory}
          disabled={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(InternalReferenceField, FIELD_NAME))
